import { Grid, Paper } from '@mui/material';
import { Outlet, useParams } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useState, useEffect } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useTranslation } from 'react-i18next';
import { getAssociationById } from 'src/shared/services/associationService';
import FormLoaderWrapper from 'src/shared/components/organisms/formLoaderWrapper';
import AssociationPageTabNavigation from '../components/associationPageTabNavigation';
import { AssociationResponse } from '../models/associationResponse';

export const AssociationPage = () => {
  const params = useParams();
  const { t } = useTranslation(['common']);
  const [loading, setLoading] = useState<boolean>(false);

  const isMounted = useIsMounted();

  const [association, setAssociation] = useState<AssociationResponse>();

  const associationPageTabs: SelectableItem[] = [
    {
      label: t('common:organization.pageTabs.form'),
      value: `${RoutesEnum.OrganizationAssocations}/${params.id}`,
    },
    {
      label: t('common:organization.pageTabs.fee'),
      value: `${RoutesEnum.OrganizationAssocations}/${params.id}/avgift`,
    },
    {
      label: t('common:organization.pageTabs.board'),
      value: `${RoutesEnum.OrganizationAssocations}/${params.id}/styrelse`,
    },
    {
      label: t('common:organization.pageTabs.elected'),
      value: `${RoutesEnum.OrganizationAssocations}/${params.id}/fortroendevalda`,
    },
    {
      label: t('common:organization.pageTabs.users'),
      value: `${RoutesEnum.OrganizationAssocations}/${params.id}/users`,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getAssociationById(params.id);
        if (isMounted()) {
          setAssociation(result.data);
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      } finally {
        if (isMounted()) setLoading(false);
      }
    };
    if (params.id) {
      fetchData();
    }
  }, [isMounted, params.id]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MainContentHeader title={association?.localAss ?? ''} />
      </Grid>
      <Grid item xs={12}>
        <FormLoaderWrapper loading={loading}>
          <Paper>
            <AssociationPageTabNavigation tabs={associationPageTabs} />
            <Outlet />
          </Paper>
        </FormLoaderWrapper>
      </Grid>
    </Grid>
  );
};
